import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthenticationProvider";
import { useRouting } from "../Hooks/Routes";
import { AppBackdropProgress } from "../Components/Progress/AppBackdropProgress";
import { messaging } from "JS/Helpers/UserMessaging";
import { ReactNode } from "react";

interface PrivateRouteProps {
    children?: ReactNode;
    element?: ReactNode;
}

const PrivateRoute = ({ children, element }: PrivateRouteProps) => {
    const { isAuthenticated, loading, sessionLoading, firebaseAuthReady } =
        useAuth();
    const { linkProvider } = useRouting();

    if (loading || sessionLoading) {
        return (
            <AppBackdropProgress
                open={true}
                backdropText={messaging?.loader?.loadingSession}
            />
        );
    }

    if (isAuthenticated && !firebaseAuthReady) {
        return (
            <AppBackdropProgress
                open={true}
                backdropText={messaging?.loader?.loadingSession}
            />
        );
    }

    return !loading && isAuthenticated === true ? (
        element ?? children
    ) : (
        <Navigate to={linkProvider.react.login()} replace />
    );
};

export default PrivateRoute;
